import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';


@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [TranslateModule, MatButtonToggleModule],
  templateUrl: './language-switch.component.html',
  styleUrl: './language-switch.component.css'
})
export class LanguageSwitchComponent {
  availableLanguages: any[] = [
    { code: 'en', displayName: 'English' },
    { code: 'ur', displayName: 'Urdu' },
  ];
  selectedLanguage: string = this.translate.currentLang;

  constructor(private translate: TranslateService) { }
  ngOnInit() {
    this.translate.onLangChange.subscribe((lang: string) => {
      this.selectedLanguage = lang;
    });
  }

  onLanguageChange(language: string) {
    this.translate.use(language);
    this.selectedLanguage = language;
  }
}
